import { cn } from "@/lib/utils";
import type { Change } from "@/types/booking-history/bookinghistorydetail";
import { safeFormatDateTime } from "@/utils/formatDate";

type HistoryCardProps = {
  history: Change[];
};

export function HistoryCard({ history }: HistoryCardProps) {
  return (
    <>
      <h2 className="mt-8 text-lg font-semibold text-secondary-foreground">
        History
      </h2>
      <section className="overflow-hidden rounded-2xl bg-card shadow-xl mt-2">
        <div className="flex items-center justify-between gap-2 bg-primary px-4 py-2 text-xs font-medium text-white md:px-6 md:text-sm">
          <span>Date/Time</span>
          <span className="text-end">Description</span>
        </div>
        <div className="flex flex-col px-4 md:px-6">
          {history.map((entry, index) => (
            <div
              key={entry.action}
              className={cn(
                "flex items-center justify-between gap-4 py-4 text-xs font-medium text-muted-foreground md:text-sm",
                index !== history.length - 1 && "border-b border-border",
              )}
            >
              <span className="text-muted-foreground">
                {safeFormatDateTime(entry.createdOn)}
              </span>
              <span className="text-muted-foreground">{entry.action}</span>
            </div>
          ))}
          {history.length === 0 && (
            <p className="text-muted-foreground py-3 text-sm">
              No history available for this booking.
            </p>
          )}
        </div>
      </section>
    </>
  );
}
